import { ParsedPartner, logger, parsePartner } from "@justhome/common";
import { fetchGetPartner } from "@justhome/api-core";

export const getPartner = async (id: string): Promise<ParsedPartner | null> => {
  try {
    const partner = await fetchGetPartner({
      pathParams: { id },
    });
    if (!partner) {
      return null;
    }
    return parsePartner(partner);
  } catch (e) {
    logger.error(`Cannot fetch partner ${id}`, e);
    return null;
  }
};
